import React, { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import { Formik, useFormik, Field, FieldArray } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Input from '@material-ui/core/Input';
import { Grid } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import token from '../../config/token';
import { CommonConfig } from '../../config/common-config';
import { useLocation } from 'react-router';

const useStyles = makeStyles((theme) => ({
    btnbottom: {
        borderBottom: '#feef6',
    },

    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
            width: '100%',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileNameMargin: {
        marginTop: '6px',
        marginBottom: '0px'
    },
    flexRow: {
        flexDirection: 'row !important'
    },
    removeButton: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '15px !important'
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '6px',
    },
    imgView: {
        borderRadius: '8px',
        marginLeft: '12px',
        background: '#e8e7e7',
        padding: '6px 0px 5px 10px',
        marginBottom: '10px',
    },
    searchClient: {
        borderBottom: 'none !important',
        background: '#eaeaf4',
        padding: '6px 2px 0px 9px',
        borderRadius: '5px',
        "& .MuiInput-underline:after": {
            border: "none"
        },
        "& .MuiIconButton-label": {
            marginTop: '-2px !important'
        }
    },
    clientView: {
        padding: '12px 18px 15px 0px',
        marginBottom: '16px !important'
    },
    labelView: {
        marginBottom: '6px',
        fontWeight: '500',
        color: '#4c4c4dd1 !important',
        fontSize: '15px !important',
        fontFamily: 'Rubik'
    }
}));

export default function ViewInvoices(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const location = useLocation();
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [showLoaderSave, setShowLoaderSave] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successpopsubmit, setSuccessPopSubmit] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [state, setState] = React.useState({
        checkedA: true,
    });

    const history = useHistory();
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [isDisable, setIsDisable] = useState(true);
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [URLValue, setURLValue] = useState();
    const [URLValueData, setURLValueData] = useState([]);
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [attachedFilename, setAttachedFilename] = useState('');
    const [uploadDisable, setUploadDisable] = useState(true);
    const [fileIndex, setFileIndex] = useState();
    const [visible, setVisible] = React.useState(false);
    const coreFilename = [];
    const [downloadFile, setDownloadFile] = useState('');
    const [IMCIndex, setIMCIndex] = useState('');
    const [attachedFileIMC, setAttachedFileIMC] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const imcdraftsavevalue = useSelector((state) => state.draftreducer.imcdraftsave);
    const imcdraftsavevalue1 = imcdraftsavevalue && imcdraftsavevalue.params;
    const imcdraftsavevalue2 = imcdraftsavevalue1 && imcdraftsavevalue1.draftDocuments;
    const [fileList, setFileList] = useState([]);
    const UploadFileList = [];
    let dateValue = new Date().toISOString().split('T')[0];
    const [checklist, setChecklist] = useState([]);
    const [IMCList, setIMCList] = useState([]);
    const tempArr = [];
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const tokens = token();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [totalClient, setTotalClient] = useState([]);
    const [rows, setRows] = useState([]);
    const [clientName, setClientName] = useState('');

    useEffect(() => {
        console.log('location', location.state)
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/auth/view-generic-invoice-particulars/${location && location.state ? location.state.id : ''}/${dbname}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    // formatDate(response.data)
                    let tempObj = JSON.parse(response.data.finalDocAndReports)
                    console.log('aaaa', tempObj)
                    setClientName(response.data.clientName)

                    setRows([tempObj]);
                    // handleRowChange(response.data);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult && errResult.data) {
                }
            });
    }, [bearerToken]);

    //append comma
    function numberWithCommas(x) {
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }

    const addAmount = (arr) => {
        let temp = [];
        arr.filter((ele) => {
            temp.push(ele.amountForInvoice)
        })
        return numberWithCommas(eval(temp.join("+")));
    }

    const navigateBack = () => {
        history.push({
            pathname: '/menu/Invoices',
        });
    }

    return (
        <div>
            <Card className="clientcard">
                <CardContent className="client-heading">
                    <Typography variant="h5">{clientName}</Typography>
                </CardContent>
                <CardContent>
                    <Card className={classes.clientView}>
                        <Grid item xs={12} sm={12} style={{ display: "flex" }}>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ fontWeight: '600' }}>
                                    Particulars
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ float: 'right', fontWeight: '600' }}>
                                    Amount
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} style={{ display: "flex", fontWeight: '500' }}>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ fontWeight: '400', marginBottom: '0px' }}>
                                    {rows && rows.length && rows[0].particulars ?
                                        rows[0].particulars.map((ele) => {
                                            return (
                                                <div style={{ marginBottom: '6px' }}>{ele.particularsText} {ele.descriptionForInvoice ? '(' + ele.descriptionForInvoice + ')' : null}</div>
                                            )
                                        })
                                        : null}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ float: 'right', fontWeight: '400', marginBottom: '0px' }}>
                                    {rows && rows.length && rows[0].particulars ?
                                        rows[0].particulars.map((ele) => {
                                            return (
                                                <div style={{ marginBottom: '6px', textAlign: 'end' }}>{numberWithCommas(ele.amountForInvoice)}</div>
                                            )
                                        })
                                        : null}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} style={{ display: "flex", fontWeight: '500' }}>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ fontWeight: '600' }}>
                                    Total
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.labelView} htmlFor="services" style={{ float: 'right', fontWeight: '600' }}>
                                    {rows && rows.length && rows[0].particulars ?
                                        addAmount(rows[0].particulars) : ''}
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </CardContent>
            </Card>
            <div className="footer-button">
                <ul>
                    <li>
                        <Button
                            color="primary"
                            className="buttonnext txt-cap"
                            onClick={() => navigateBack()}
                        >  Back
                        </Button>
                    </li>
                </ul>
            </div>
        </div >
    );
}
